import type { ProductsLandingAttributes } from '../../../types/cms'
import { Container, Grid, Box, Stack } from '@mui/material'
import { CmsButton } from '../../Button'
import { MarkdownText } from 'ui-kit'
import { ProductsBackground, InfoContainer } from './styles'
import MobileTechnologyHeader from '../../MobileTechnologyHeader'
import TechnologyLogo from '../../TechnologyLogo'
import IconChip from '../../IconChip'
import FormattedImage from '../../FormattedImage'
import { resizeImage } from '../../../utils/resizeImage'

const ProductsLanding = ({
  backgroundImage,
  buttons,
  info,
  logo,
  productImage,
  title,
  textColour,
  mobileHeaderColour,
  mobileBackgroundImage,
  chip,
  isHomepage,
}: ProductsLandingAttributes) => {
  if (!backgroundImage?.data?.attributes?.url) return null

  return (
    <>
      <MobileTechnologyHeader
        mobileHeaderColour={mobileHeaderColour}
        mobileBackgroundImage={mobileBackgroundImage}
        gradientHeight={'18.5rem'}
        logo={logo}
        title={title}
        info={info}
        titleColour={textColour}
        buttons={buttons}
        chip={chip}
        isHomepage={isHomepage}
      />
      <Box sx={{ display: { xs: 'none', md: 'block' }, overflow: 'hidden' }}>
        <ProductsBackground
          backgroundImage={backgroundImage.data.attributes.url}
        >
          <Container
            maxWidth="lg"
            sx={{ overflow: { xs: 'hidden', lg: 'initial' } }}
          >
            <Grid container rowSpacing={4} justifyContent="space-between">
              <Grid item xs={12} md={6}>
                <InfoContainer
                  justifyContent={'space-between'}
                  textColour={textColour}
                  spacing={4}
                >
                  <TechnologyLogo logo={logo} />
                  <MarkdownText>{title}</MarkdownText>
                  {chip?.data?.attributes && (
                    <IconChip {...chip.data.attributes} />
                  )}
                  <MarkdownText>{info}</MarkdownText>
                  <Stack direction="row" spacing={4}>
                    {(buttons ?? []).map((button, idx) => (
                      <CmsButton
                        href={button.link ?? ''}
                        backgroundColor={button.backgroundColour}
                        color={button.textColour}
                        key={button.text}
                        target={button.target}
                        rel={button.rel}
                      >
                        {idx === 0 && (
                          <Box
                            sx={{
                              marginRight: '1rem',
                              display: 'inline-flex',
                            }}
                          >
                            <img
                              src="/icon_play_small_black.svg"
                              alt="Play"
                              width={14}
                              height={18}
                              style={{
                                filter:
                                  button.textColour
                                    ?.substring(0, 4)
                                    .toUpperCase() === '#FFF'
                                    ? 'invert(1)'
                                    : undefined,
                              }}
                            />
                          </Box>
                        )}
                        {button.text}
                      </CmsButton>
                    ))}
                  </Stack>
                </InfoContainer>
              </Grid>
              <Grid item xs={12} md={6}>
                {productImage?.data?.attributes && (
                  <Box
                    sx={{
                      width: resizeImage(
                        productImage.data.attributes.width ?? 0,
                      ),
                      height: resizeImage(
                        productImage.data.attributes.height ?? 0,
                      ),
                    }}
                  >
                    <FormattedImage image={productImage} />
                  </Box>
                )}
              </Grid>
            </Grid>
          </Container>
        </ProductsBackground>
      </Box>
    </>
  )
}

export default ProductsLanding
